// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1e0c116y{display:inline-flex}\n._dzc21h6o >div{align-items:center}\n._vwz41j6v{line-height:1rem}\n._1ilq1i6y >div button:focus-visible{outline-offset:var(--ds-space-negative-025,-2px)}", ""]);
// Exports
module.exports = exports;
